import '../common/_commonjsHelpers-8c19dec8.js';
import { r as react, R as React } from '../common/index-0a062023.js';
import { r as reactDom } from '../common/index-37ed1a2c.js';

const qn = {
  day: "numeric",
  weekday: "long",
  month: "long",
  year: "numeric"
}, dr = {
  hour: "2-digit",
  minute: "2-digit"
};
function Zo(e, t) {
  if (t)
    try {
      const [r, n] = e.split("T"), [a, i, s] = r.split("-"), u = n.substring(0, 5), [l, c] = u.split(":");
      return new Date(
        Number(a),
        Number(i) - 1,
        Number(s),
        Number(l),
        Number(c)
      );
    } catch (r) {
      return console.error(r), new Date(e);
    }
  else
    return new Date(e);
}
function Xo(e, t = "en-GB", r = qn, n = dr) {
  let a = e.toLocaleDateString(t, r);
  a = Ke(a) + ", ";
  const i = e.toLocaleTimeString(
    t,
    n
  );
  return a + (t === "da-DK" ? "kl. " : "") + i;
}
function Ho(e, t, {
  dateJoiner: r = " - ",
  timeJoiner: n = "-",
  dateLocale: a = "en-GB",
  showTime: i = !0,
  shortForm: s = !1,
  longForm: u = !1
} = {}) {
  const l = s && !u ? "short" : "long", c = e.toLocaleDateString(a, {
    weekday: l,
    year: "numeric",
    month: l,
    day: "numeric"
  }), d = e.toLocaleTimeString(
    a,
    dr
  ), f = t.toLocaleTimeString(
    a,
    dr
  ), v = t.toLocaleDateString(a, {
    weekday: l,
    year: "numeric",
    month: l,
    day: "numeric"
  }), p = a === "da-DK" ? "kl. " : "";
  if (on(e, t)) {
    let M = Ke(c) + (i ? ", " + p + d + n + f : "");
    return s && a === "da-DK" && (M = M.split(" den ").join(" ")), M;
  } else {
    if (u)
      return Ke(c) + ", " + p + d + r + Ke(v) + ", " + p + f;
    if (yi(e, t) && !u) {
      let M = e.toLocaleDateString(a, {
        weekday: l,
        day: "numeric"
      });
      a === "da-DK" && (M.includes("den") || (M = M.replace(" ", " den ")));
      let w = Ke(M) + r + t.toLocaleDateString(a, {
        ...qn,
        weekday: l,
        day: "numeric"
      });
      return on(e, t) || (w = w.replace(",", "")), s && a === "da-DK" && (w = w.split(" den ").join(" ")), w;
    } else
      return vi(e, t) && !u ? e.toLocaleDateString(a, {
        day: "numeric",
        month: l
      }) + r + t.toLocaleDateString(a, {
        day: "numeric",
        month: l,
        year: "numeric"
      }) : e.toLocaleDateString(a, {
        day: "numeric",
        month: l,
        year: "numeric"
      }) + r + t.toLocaleDateString(a, {
        day: "numeric",
        month: l,
        year: "numeric"
      });
  }
}
function on(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function yi(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth();
}
function vi(e, t) {
  return e.getFullYear() === t.getFullYear();
}
function Ke(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var hr = { exports: {} }, Ye = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var rr, un;
function Gn() {
  if (un)
    return rr;
  un = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return rr = a() ? Object.assign : function(i, s) {
    for (var u, l = n(i), c, d = 1; d < arguments.length; d++) {
      u = Object(arguments[d]);
      for (var f in u)
        t.call(u, f) && (l[f] = u[f]);
      if (e) {
        c = e(u);
        for (var v = 0; v < c.length; v++)
          r.call(u, c[v]) && (l[c[v]] = u[c[v]]);
      }
    }
    return l;
  }, rr;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cn;
function bi() {
  if (cn)
    return Ye;
  cn = 1, Gn();
  var e = react, t = 60103;
  if (Ye.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), Ye.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, l, c) {
    var d, f = {}, v = null, p = null;
    c !== void 0 && (v = "" + c), l.key !== void 0 && (v = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (d in l)
      a.call(l, d) && !i.hasOwnProperty(d) && (f[d] = l[d]);
    if (u && u.defaultProps)
      for (d in l = u.defaultProps, l)
        f[d] === void 0 && (f[d] = l[d]);
    return { $$typeof: t, type: u, key: v, ref: p, props: f, _owner: n.current };
  }
  return Ye.jsx = s, Ye.jsxs = s, Ye;
}
 hr.exports = bi() ;
var V = hr.exports;
/**
  * @reach/utils v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */
function Zn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function J(e, t) {
  return (r) => {
    if (e && e(r), !r.defaultPrevented)
      return t(r);
  };
}
function fn(e) {
  return typeof e == "boolean";
}
function At(e) {
  return !!(e && {}.toString.call(e) == "[object Function]");
}
function Mi(e) {
  return typeof e == "string";
}
function wi(e, t) {
  if (e != null)
    if (At(e))
      e(t);
    else
      try {
        e.current = t;
      } catch {
        throw new Error(`Cannot assign value "${t}" to ref "${e}"`);
      }
}
function gt(...e) {
  return react.useCallback((t) => {
    for (let r of e)
      wi(r, t);
  }, e);
}
function at(e) {
  return Zn() ? e ? e.ownerDocument : document : null;
}
function Ii(e, t) {
  let r = react.createContext(t);
  function n(i) {
    let { children: s, ...u } = i, l = react.useMemo(() => u, Object.values(u));
    return /* @__PURE__ */ react.createElement(r.Provider, {
      value: l
    }, s);
  }
  function a(i) {
    let s = react.useContext(r);
    if (s)
      return s;
    if (t)
      return t;
    throw Error(`${i} must be rendered inside of a ${e} component.`);
  }
  return r.displayName = `${e}Context`, n.displayName = `${e}Provider`, [n, a];
}
function Dt(e) {
  return "which" in e ? e.which === 3 : "button" in e ? e.button === 2 : !1;
}
function Ct(...e) {
  return e.filter((t) => t != null).join("--");
}
function Ar() {
}
function Xn() {
  let [, e] = react.useState(/* @__PURE__ */ Object.create(null));
  return react.useCallback(() => {
    e(/* @__PURE__ */ Object.create(null));
  }, []);
}
var Ue = Zn() ? react.useLayoutEffect : react.useEffect;
function ar(e) {
  const t = react.useRef(null);
  return react.useEffect(() => {
    t.current = e;
  }, [e]), t.current;
}
function Ti(e, t) {
  let [r, n] = react.useState(t), a = react.useCallback((i) => {
    e.current = i, n(i);
  }, []);
  return [r, a];
}
var Ni = ({
  children: e,
  type: t = "reach-portal",
  containerRef: r
}) => {
  let n = react.useRef(null), a = react.useRef(null), i = Xn();
  return react.useEffect(() => {
    r != null && (typeof r != "object" || !("current" in r) ? console.warn("@reach/portal: Invalid value passed to the `containerRef` of a `Portal`. The portal will be appended to the document body, but if you want to attach it to another DOM node you must pass a valid React ref object to `containerRef`.") : r.current == null && console.warn("@reach/portal: A ref was passed to the `containerRef` prop of a `Portal`, but no DOM node was attached to it. Be sure to pass the ref to a DOM component.\n\nIf you are forwarding the ref from another component, be sure to use the React.forwardRef API. See https://reactjs.org/docs/forwarding-refs.html."));
  }, [r]), Ue(() => {
    if (!n.current)
      return;
    let s = n.current.ownerDocument, u = (r == null ? void 0 : r.current) || s.body;
    return a.current = s == null ? void 0 : s.createElement(t), u.appendChild(a.current), i(), () => {
      a.current && u && u.removeChild(a.current);
    };
  }, [t, i, r]), a.current ? reactDom.createPortal(e, a.current) : /* @__PURE__ */ react.createElement("span", {
    ref: n
  });
}, Hn = ({
  unstable_skipInitialRender: e,
  ...t
}) => {
  let [r, n] = react.useState(!1);
  return react.useEffect(() => {
    e && n(!0);
  }, [e]), e && !r ? null : /* @__PURE__ */ react.createElement(Ni, {
    ...t
  });
};
Hn.displayName = "Portal";
var Si = ["bottom", "height", "left", "right", "top", "width"], _i = function(t, r) {
  return t === void 0 && (t = {}), r === void 0 && (r = {}), Si.some(function(n) {
    return t[n] !== r[n];
  });
}, ye = /* @__PURE__ */ new Map(), Kn, Di = function e() {
  var t = [];
  ye.forEach(function(r, n) {
    var a = n.getBoundingClientRect();
    _i(a, r.rect) && (r.rect = a, t.push(r));
  }), t.forEach(function(r) {
    r.callbacks.forEach(function(n) {
      return n(r.rect);
    });
  }), Kn = window.requestAnimationFrame(e);
};
function xi(e, t) {
  return {
    observe: function() {
      var n = ye.size === 0;
      ye.has(e) ? ye.get(e).callbacks.push(t) : ye.set(e, {
        rect: void 0,
        hasRectChanged: !1,
        callbacks: [t]
      }), n && Di();
    },
    unobserve: function() {
      var n = ye.get(e);
      if (n) {
        var a = n.callbacks.indexOf(t);
        a >= 0 && n.callbacks.splice(a, 1), n.callbacks.length || ye.delete(e), ye.size || cancelAnimationFrame(Kn);
      }
    }
  };
}
function dn(e, t, r) {
  let n, a;
  fn(t) ? n = t : (n = (t == null ? void 0 : t.observe) ?? !0, a = t == null ? void 0 : t.onChange), At(r) && (a = r), react.useEffect(() => {
    fn(t) && console.warn("Passing `observe` as the second argument to `useRect` is deprecated and will be removed in a future version of Reach UI. Instead, you can pass an object of options with an `observe` property as the second argument (`useRect(ref, { observe })`).\nSee https://reach.tech/rect#userect-observe");
  }, [t]), react.useEffect(() => {
    At(r) && console.warn("Passing `onChange` as the third argument to `useRect` is deprecated and will be removed in a future version of Reach UI. Instead, you can pass an object of options with an `onChange` property as the second argument (`useRect(ref, { onChange })`).\nSee https://reach.tech/rect#userect-onchange");
  }, [r]);
  let [i, s] = react.useState(e.current), u = react.useRef(!1), l = react.useRef(!1), [c, d] = react.useState(null), f = react.useRef(a);
  return Ue(() => {
    f.current = a, e.current !== i && s(e.current);
  }), Ue(() => {
    i && !u.current && (u.current = !0, d(i.getBoundingClientRect()));
  }, [i]), Ue(() => {
    if (!n)
      return;
    let v = i;
    if (l.current || (l.current = !0, v = e.current), !v) {
      console.warn("You need to place the ref");
      return;
    }
    let p = xi(v, (M) => {
      var w;
      (w = f.current) == null || w.call(f, M), d(M);
    });
    return p.observe(), () => {
      p.unobserve();
    };
  }, [n, i, e]), c;
}
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ji = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], pr = /* @__PURE__ */ ji.join(","), Jn = typeof Element > "u", it = Jn ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, mr = !Jn && Element.prototype.getRootNode ? function(e) {
  return e.getRootNode();
} : function(e) {
  return e.ownerDocument;
}, Ai = function(t, r, n) {
  var a = Array.prototype.slice.apply(t.querySelectorAll(pr));
  return r && it.call(t, pr) && a.unshift(t), a = a.filter(n), a;
}, Ci = function e(t, r, n) {
  for (var a = [], i = Array.from(t); i.length; ) {
    var s = i.shift();
    if (s.tagName === "SLOT") {
      var u = s.assignedElements(), l = u.length ? u : s.children, c = e(l, !0, n);
      n.flatten ? a.push.apply(a, c) : a.push({
        scope: s,
        candidates: c
      });
    } else {
      var d = it.call(s, pr);
      d && n.filter(s) && (r || !t.includes(s)) && a.push(s);
      var f = s.shadowRoot || // check for an undisclosed shadow
      typeof n.getShadowRoot == "function" && n.getShadowRoot(s), v = !n.shadowRootFilter || n.shadowRootFilter(s);
      if (f && v) {
        var p = e(f === !0 ? s.children : f.children, !0, n);
        n.flatten ? a.push.apply(a, p) : a.push({
          scope: s,
          candidates: p
        });
      } else
        i.unshift.apply(i, s.children);
    }
  }
  return a;
}, ea = function(t, r) {
  return t.tabIndex < 0 && (r || /^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || t.isContentEditable) && isNaN(parseInt(t.getAttribute("tabindex"), 10)) ? 0 : t.tabIndex;
}, Ri = function(t, r) {
  return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
}, ta = function(t) {
  return t.tagName === "INPUT";
}, Oi = function(t) {
  return ta(t) && t.type === "hidden";
}, Pi = function(t) {
  var r = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return r;
}, Li = function(t, r) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === r)
      return t[n];
}, ki = function(t) {
  if (!t.name)
    return !0;
  var r = t.form || mr(t), n = function(u) {
    return r.querySelectorAll('input[type="radio"][name="' + u + '"]');
  }, a;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    a = n(window.CSS.escape(t.name));
  else
    try {
      a = n(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var i = Li(a, t.form);
  return !i || i === t;
}, zi = function(t) {
  return ta(t) && t.type === "radio";
}, Yi = function(t) {
  return zi(t) && !ki(t);
}, hn = function(t) {
  var r = t.getBoundingClientRect(), n = r.width, a = r.height;
  return n === 0 && a === 0;
}, Fi = function(t, r) {
  var n = r.displayCheck, a = r.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = it.call(t, "details>summary:first-of-type"), s = i ? t.parentElement : t;
  if (it.call(s, "details:not([open]) *"))
    return !0;
  var u = mr(t).host, l = (u == null ? void 0 : u.ownerDocument.contains(u)) || t.ownerDocument.contains(t);
  if (!n || n === "full") {
    if (typeof a == "function") {
      for (var c = t; t; ) {
        var d = t.parentElement, f = mr(t);
        if (d && !d.shadowRoot && a(d) === !0)
          return hn(t);
        t.assignedSlot ? t = t.assignedSlot : !d && f !== t.ownerDocument ? t = f.host : t = d;
      }
      t = c;
    }
    if (l)
      return !t.getClientRects().length;
  } else if (n === "non-zero-area")
    return hn(t);
  return !1;
}, Ui = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var r = t.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var n = 0; n < r.children.length; n++) {
          var a = r.children.item(n);
          if (a.tagName === "LEGEND")
            return it.call(r, "fieldset[disabled] *") ? !0 : !a.contains(t);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, Qi = function(t, r) {
  return !(r.disabled || Oi(r) || Fi(r, t) || // For a details element with a summary, the summary element gets the focus
  Pi(r) || Ui(r));
}, pn = function(t, r) {
  return !(Yi(r) || ea(r) < 0 || !Qi(t, r));
}, $i = function(t) {
  var r = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, Vi = function e(t) {
  var r = [], n = [];
  return t.forEach(function(a, i) {
    var s = !!a.scope, u = s ? a.scope : a, l = ea(u, s), c = s ? e(a.candidates) : u;
    l === 0 ? s ? r.push.apply(r, c) : r.push(u) : n.push({
      documentOrder: i,
      tabIndex: l,
      item: a,
      isScope: s,
      content: c
    });
  }), n.sort(Ri).reduce(function(a, i) {
    return i.isScope ? a.push.apply(a, i.content) : a.push(i.content), a;
  }, []).concat(r);
}, de = function(t, r) {
  r = r || {};
  var n;
  return r.getShadowRoot ? n = Ci([t], r.includeContainer, {
    filter: pn.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: $i
  }) : n = Ai(t, r.includeContainer, pn.bind(null, r)), Vi(n);
}, Cr = react.forwardRef(function({ unstable_skipInitialPortalRender: t, ...r }, n) {
  return /* @__PURE__ */ react.createElement(Hn, {
    unstable_skipInitialRender: t
  }, /* @__PURE__ */ react.createElement(ra, {
    ref: n,
    ...r
  }));
});
Cr.displayName = "Popover";
var ra = react.forwardRef(function({
  as: t = "div",
  targetRef: r,
  position: n = qi,
  unstable_observableRefs: a = [],
  ...i
}, s) {
  const u = react.useRef(null), l = dn(u, { observe: !i.hidden }), c = dn(r, { observe: !0 }), d = gt(u, s);
  return Zi(r, u), /* @__PURE__ */ react.createElement(t, {
    "data-reach-popover": "",
    ref: d,
    ...i,
    style: {
      position: "absolute",
      ...Bi(n, c, l, ...a),
      ...i.style
    }
  });
});
ra.displayName = "PopoverImpl";
function Bi(e, t, r, ...n) {
  return r ? e(t, r, ...n.map((a) => a.current)) : { visibility: "hidden" };
}
function Wi(e, t, r) {
  return {
    top: r ? `${e.top - t.height + window.pageYOffset}px` : `${e.top + e.height + window.pageYOffset}px`
  };
}
var qi = (e, t) => {
  if (!e || !t)
    return {};
  const { directionRight: r, directionUp: n } = Gi(e, t);
  return {
    left: r ? `${e.right - t.width + window.pageXOffset}px` : `${e.left + window.pageXOffset}px`,
    ...Wi(e, t, n)
  };
};
function Gi(e, t, r = 0, n = 0) {
  const a = {
    top: e.top - t.height < 0,
    right: window.innerWidth < e.left + t.width - r,
    bottom: window.innerHeight < e.bottom + t.height - n,
    left: e.left + e.width - t.width < 0
  }, i = a.right && !a.left, s = a.left && !a.right, u = a.bottom && !a.top, l = a.top && !a.bottom;
  return { directionRight: i, directionLeft: s, directionUp: u, directionDown: l };
}
function Zi(e, t) {
  const r = at(e.current);
  function n(m) {
    m.key === "Tab" && t.current && de(t.current).length === 0 || (m.key === "Tab" && m.shiftKey ? c(m) ? d(m) : f(m) ? v(m) : M(m) && N() : m.key === "Tab" && (i() ? s(m) : u() ? l(m) : p(m) && N()));
  }
  react.useEffect(() => (r.addEventListener("keydown", n), () => {
    r.removeEventListener("keydown", n);
  }), []);
  function a() {
    const m = de(r), h = m && e.current ? m.indexOf(e.current) : -1, S = m && m[h + 1];
    return t.current && t.current.contains(S || null) ? !1 : S;
  }
  function i() {
    return e.current ? e.current === r.activeElement : !1;
  }
  function s(m) {
    const h = t.current && de(t.current);
    h && h[0] && (m.preventDefault(), h[0].focus());
  }
  function u() {
    if (t.current ? t.current.contains(r.activeElement || null) : !1) {
      const h = t.current && de(t.current);
      return !!(h && h[h.length - 1] === r.activeElement);
    }
    return !1;
  }
  function l(m) {
    const h = a();
    h && (m.preventDefault(), h.focus());
  }
  function c(m) {
    if (!m.shiftKey)
      return;
    const h = a();
    return m.target === h;
  }
  function d(m) {
    const h = t.current && de(t.current), S = h && h[h.length - 1];
    S && (m.preventDefault(), S.focus());
  }
  function f(m) {
    const h = t.current && de(t.current);
    return h ? h.length === 0 ? !1 : m.target === h[0] : !1;
  }
  function v(m) {
    var h;
    m.preventDefault(), (h = e.current) == null || h.focus();
  }
  function p(m) {
    const h = t.current ? de(r).filter((S) => !t.current.contains(S)) : null;
    return h ? m.target === h[h.length - 1] : !1;
  }
  function M(m) {
    return m.target === de(r)[0];
  }
  let w = [];
  function N() {
    const m = t.current && de(t.current);
    m && (m.forEach((h) => {
      w.push([h, h.tabIndex]), h.tabIndex = -1;
    }), r.addEventListener("focusin", I));
  }
  function I() {
    r.removeEventListener("focusin", I), w.forEach(([m, h]) => {
      m.tabIndex = h;
    });
  }
}
var ir = !1, Xi = 0;
function mn() {
  return ++Xi;
}
var gn = React["useId".toString()];
function Hi(e) {
  if (gn !== void 0) {
    let a = gn();
    return e ?? a;
  }
  let t = e ?? (ir ? mn() : null), [r, n] = react.useState(t);
  return Ue(() => {
    r === null && n(mn());
  }, []), react.useEffect(() => {
    ir === !1 && (ir = !0);
  }, []), e ?? r ?? void 0;
}
function Ki(e, t = {}) {
  const r = [];
  let n = react.createContext({
    descendants: r,
    registerDescendant: () => Ar,
    ...t
  });
  return n.displayName = e, n;
}
function Ji(e, t, r) {
  let n = Xn(), { registerDescendant: a, descendants: i } = react.useContext(t), s = r ?? i.findIndex((u) => u.element === e.element);
  return Ue(() => (e.element || n(), a({ ...e, index: s })), [
    e,
    n,
    s,
    a,
    ...Object.values(e)
  ]), s;
}
function es() {
  return react.useState([]);
}
function ts(e) {
  return react.useContext(e).descendants;
}
function rs({
  context: e,
  children: t,
  items: r,
  set: n
}) {
  let a = react.useCallback(({
    element: i,
    index: s,
    ...u
  }) => i ? (n((l) => {
    if (s != null && s !== -1)
      return yn(l, { element: i, index: s, ...u }, s);
    if (l.length === 0)
      return [{ ...u, element: i, index: 0 }];
    if (l.find((f) => f.element === i))
      return console.warn(`[reach-ui]: \`useDescendant\` was called with an element that was already registered.

If you are using the \`@reach/descendants\` package directly, make sure to only register descendants once. Registering a descendant more than once will lead to bugs in your app.

If you are using another \`reach-ui\` package, this is probably our bug!

To report a bug, open a new issue:

  https://github.com/reach/reach-ui/issues/new?assignees=&labels=&template=Bug_report.md

IMPORTANT: this check will only run in the development build, so if you see this warning please be aware that your app may crash when deployed.`), is(l);
    let c = as(l, i), d;
    return c === -1 ? d = [
      ...l,
      { ...u, element: i, index: l.length }
    ] : d = yn(l, { ...u, element: i, index: c }, c), d;
  }), () => {
    i && n((l) => l.filter((c) => i !== c.element));
  }) : Ar, []);
  return /* @__PURE__ */ react.createElement(e.Provider, {
    value: react.useMemo(() => ({
      descendants: r,
      registerDescendant: a
    }), [r, a])
  }, t);
}
function ns(e, t) {
  let { descendants: r } = react.useContext(e), {
    callback: n,
    currentIndex: a,
    filter: i,
    key: s = "index",
    orientation: u = "vertical",
    rotate: l = !0,
    rtl: c = !1
  } = t;
  return function(f) {
    if (![
      "ArrowDown",
      "ArrowUp",
      "ArrowLeft",
      "ArrowRight",
      "PageUp",
      "PageDown",
      "Home",
      "End"
    ].includes(f.key))
      return;
    let v = a ?? -1, p = i ? r.filter(i) : r;
    if (!p.length)
      return;
    let M = p.findIndex((h) => h.index === a);
    function w() {
      return v === m().index ? l ? I() : p[M] : p[(M + 1) % p.length];
    }
    function N() {
      return v === I().index ? l ? m() : p[M] : p[(M - 1 + p.length) % p.length];
    }
    function I() {
      return p[0];
    }
    function m() {
      return p[p.length - 1];
    }
    switch (f.key) {
      case "ArrowDown":
        if (u === "vertical" || u === "both") {
          f.preventDefault();
          let x = w();
          n(s === "option" ? x : x[s]);
        }
        break;
      case "ArrowUp":
        if (u === "vertical" || u === "both") {
          f.preventDefault();
          let x = N();
          n(s === "option" ? x : x[s]);
        }
        break;
      case "ArrowLeft":
        if (u === "horizontal" || u === "both") {
          f.preventDefault();
          let x = (c ? w : N)();
          n(s === "option" ? x : x[s]);
        }
        break;
      case "ArrowRight":
        if (u === "horizontal" || u === "both") {
          f.preventDefault();
          let x = (c ? N : w)();
          n(s === "option" ? x : x[s]);
        }
        break;
      case "PageUp":
        f.preventDefault();
        let h = (f.ctrlKey ? N : I)();
        n(s === "option" ? h : h[s]);
        break;
      case "Home":
        f.preventDefault();
        let S = I();
        n(s === "option" ? S : S[s]);
        break;
      case "PageDown":
        f.preventDefault();
        let y = (f.ctrlKey ? w : m)();
        n(s === "option" ? y : y[s]);
        break;
      case "End":
        f.preventDefault();
        let k = m();
        n(s === "option" ? k : k[s]);
        break;
    }
  };
}
function na(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function as(e, t) {
  if (!t || !e.length)
    return -1;
  let r = e.length;
  for (; r--; ) {
    let n = e[r].element;
    if (n && na(n, t))
      return r + 1;
  }
  return -1;
}
function yn(e, t, r) {
  return r == null || !(r in e) ? [...e, t] : [...e.slice(0, r), t, ...e.slice(r)];
}
function is(e) {
  return e.sort((t, r) => !t.element || !r.element ? 0 : na(t.element, r.element) ? -1 : 1).map((t, r) => ({ ...t, index: r }));
}
var aa = "CLEAR_SELECTION_INDEX", Rr = "CLICK_MENU_ITEM", st = "CLOSE_MENU", ss = "OPEN_MENU_AT_FIRST_ITEM", gr = "OPEN_MENU_AT_INDEX", ia = "OPEN_MENU_CLEARED", yr = "SEARCH_FOR_ITEM", ve = "SELECT_ITEM_AT_INDEX", vr = "SET_BUTTON_ID", Ut = Ki("DropdownDescendantContext"), [os, yt] = Ii("Dropdown"), us = {
  triggerId: null,
  isExpanded: !1,
  typeaheadQuery: "",
  selectionIndex: -1
}, sa = ({
  id: e,
  children: t
}) => {
  let r = react.useRef(null), n = react.useRef(null), a = react.useRef(null), [i, s] = es(), u = Hi(e), l = e || Ct("menu", u), c = Ct("menu-button", l), [d, f] = react.useReducer(ms, {
    ...us,
    triggerId: c
  }), v = react.useRef(!1), p = react.useRef([]), M = react.useRef(!1), w = react.useRef({ x: 0, y: 0 });
  return react.useEffect(() => {
    d.isExpanded ? (window.__REACH_DISABLE_TOOLTIPS = !0, window.requestAnimationFrame(() => {
      Rt(n.current);
    })) : window.__REACH_DISABLE_TOOLTIPS = !1;
  }, [d.isExpanded]), /* @__PURE__ */ react.createElement(rs, {
    context: Ut,
    items: i,
    set: s
  }, /* @__PURE__ */ react.createElement(os, {
    dispatch: f,
    dropdownId: l,
    dropdownRef: n,
    mouseDownStartPosRef: w,
    popoverRef: a,
    readyToSelect: M,
    selectCallbacks: p,
    state: d,
    triggerClickedRef: v,
    triggerRef: r
  }, At(t) ? t({
    isExpanded: d.isExpanded,
    isOpen: d.isExpanded
  }) : t));
};
sa.displayName = "DropdownProvider";
function oa({
  onKeyDown: e,
  onMouseDown: t,
  id: r,
  ref: n,
  ...a
}) {
  let {
    dispatch: i,
    dropdownId: s,
    mouseDownStartPosRef: u,
    triggerClickedRef: l,
    triggerRef: c,
    state: { triggerId: d, isExpanded: f }
  } = yt("useDropdownTrigger"), v = gt(c, n), p = da(), M = react.useMemo(() => p.findIndex((I) => !I.disabled), [p]);
  react.useEffect(() => {
    r != null && r !== d && i({
      type: vr,
      payload: r
    });
  }, [d, i, r]), react.useEffect(() => {
    r == null && i({
      type: vr,
      payload: Ct("menu-button", s)
    });
  }, [s, i, r]);
  function w(I) {
    switch (I.key) {
      case "ArrowDown":
      case "ArrowUp":
        I.preventDefault(), i({
          type: gr,
          payload: { index: M }
        });
        break;
      case "Enter":
      case " ":
        i({
          type: gr,
          payload: { index: M }
        });
        break;
    }
  }
  function N(I) {
    Dt(I.nativeEvent) || (u.current = {
      x: I.clientX,
      y: I.clientY
    }, f || (l.current = !0), i(f ? { type: st } : { type: ia }));
  }
  return {
    data: {
      isExpanded: f,
      controls: s
    },
    props: {
      ...a,
      ref: v,
      id: d || void 0,
      onKeyDown: J(e, w),
      onMouseDown: J(t, N),
      type: "button"
    }
  };
}
var cs = react.forwardRef(({ as: e = "button", ...t }, r) => {
  let { props: n } = oa({ ...t, ref: r });
  return /* @__PURE__ */ react.createElement(e, {
    "data-reach-dropdown-trigger": "",
    ...n
  });
});
cs.displayName = "DropdownTrigger";
function ua({
  index: e,
  isLink: t = !1,
  onClick: r,
  onDragStart: n,
  onMouseDown: a,
  onMouseEnter: i,
  onMouseLeave: s,
  onMouseMove: u,
  onMouseUp: l,
  onSelect: c,
  disabled: d,
  onFocus: f,
  valueText: v,
  ref: p,
  ...M
}) {
  let {
    dispatch: w,
    dropdownRef: N,
    mouseDownStartPosRef: I,
    readyToSelect: m,
    selectCallbacks: h,
    triggerRef: S,
    state: { selectionIndex: y, isExpanded: k }
  } = yt("useDropdownItem"), x = react.useRef(null), [F, B] = react.useState(v || ""), ne = react.useCallback((O) => {
    !v && (O != null && O.textContent) && B(O.textContent);
  }, [v]), Q = react.useRef(!1), [H, K] = Ti(x, null), q = react.useMemo(() => ({
    element: H,
    key: F,
    disabled: d,
    isLink: t
  }), [d, H, t, F]), W = Ji(q, Ut, e), ce = W === y && !d, je = gt(p, K, ne);
  h.current[W] = c;
  function pe() {
    Rt(S.current), c && c(), w({ type: Rr });
  }
  function Ae(O) {
    Dt(O.nativeEvent) || t && (d ? O.preventDefault() : pe());
  }
  function Ie(O) {
    t && O.preventDefault();
  }
  function Ce(O) {
    Dt(O.nativeEvent) || (t ? Q.current = !0 : O.preventDefault());
  }
  function Re(O) {
    let G = at(N.current);
    !ce && W != null && !d && (N != null && N.current && N.current !== G.activeElement && x.current !== G.activeElement && N.current.focus(), w({
      type: ve,
      payload: {
        index: W
      }
    }));
  }
  function Oe(O) {
    w({ type: aa });
  }
  function We(O) {
    if (!m.current) {
      let G = 8, Ne = Math.abs(O.clientX - I.current.x), me = Math.abs(O.clientY - I.current.y);
      (Ne > G || me > G) && (m.current = !0);
    }
    !ce && W != null && !d && w({
      type: ve,
      payload: {
        index: W,
        dropdownRef: N
      }
    });
  }
  function qe() {
    m.current = !0, !ce && W != null && !d && w({
      type: ve,
      payload: {
        index: W
      }
    });
  }
  function Te(O) {
    if (!Dt(O.nativeEvent)) {
      if (!m.current) {
        m.current = !0;
        return;
      }
      t ? Q.current ? Q.current = !1 : x.current && x.current.click() : d || pe();
    }
  }
  return react.useEffect(() => {
    if (k) {
      let O = window.setTimeout(() => {
        m.current = !0;
      }, 400);
      return () => {
        window.clearTimeout(O);
      };
    } else
      m.current = !1;
  }, [k, m]), react.useEffect(() => {
    let O = at(x.current);
    return O.addEventListener("mouseup", G), () => {
      O.removeEventListener("mouseup", G);
    };
    function G() {
      Q.current = !1;
    }
  }, []), {
    data: {
      disabled: d
    },
    props: {
      id: fa(W),
      tabIndex: -1,
      ...M,
      ref: je,
      "data-disabled": d ? "" : void 0,
      "data-selected": ce ? "" : void 0,
      "data-valuetext": F,
      onClick: J(r, Ae),
      onDragStart: J(n, Ie),
      onMouseDown: J(a, Ce),
      onMouseEnter: J(i, Re),
      onMouseLeave: J(s, Oe),
      onMouseMove: J(u, We),
      onFocus: J(f, qe),
      onMouseUp: J(l, Te)
    }
  };
}
var ls = react.forwardRef(({ as: e = "div", ...t }, r) => {
  let { props: n } = ua({ ...t, ref: r });
  return /* @__PURE__ */ react.createElement(e, {
    "data-reach-dropdown-item": "",
    ...n
  });
});
ls.displayName = "DropdownItem";
function ca({
  id: e,
  onKeyDown: t,
  ref: r,
  ...n
}) {
  let {
    dispatch: a,
    triggerRef: i,
    dropdownRef: s,
    selectCallbacks: u,
    dropdownId: l,
    state: { isExpanded: c, triggerId: d, selectionIndex: f, typeaheadQuery: v }
  } = yt("useDropdownItems"), p = da(), M = gt(s, r);
  react.useEffect(() => {
    let h = hs(p, v);
    v && h != null && a({
      type: ve,
      payload: {
        index: h,
        dropdownRef: s
      }
    });
    let S = window.setTimeout(() => v && a({ type: yr, payload: "" }), 1e3);
    return () => window.clearTimeout(S);
  }, [a, p, v, s]);
  let w = ar(p.length), N = ar(p[f]), I = ar(f);
  react.useEffect(() => {
    f > p.length - 1 ? a({
      type: ve,
      payload: {
        index: p.length - 1,
        dropdownRef: s
      }
    }) : w !== p.length && f > -1 && N && I === f && p[f] !== N && a({
      type: ve,
      payload: {
        index: p.findIndex((h) => h.key === (N == null ? void 0 : N.key)),
        dropdownRef: s
      }
    });
  }, [
    s,
    a,
    p,
    w,
    N,
    I,
    f
  ]);
  let m = J(function(S) {
    let { key: y } = S;
    if (c)
      switch (y) {
        case "Enter":
        case " ":
          let k = p.find((x) => x.index === f);
          k && !k.disabled && (S.preventDefault(), k.isLink && k.element ? k.element.click() : (Rt(i.current), u.current[k.index] && u.current[k.index](), a({ type: Rr })));
          break;
        case "Escape":
          Rt(i.current), a({ type: st });
          break;
        case "Tab":
          S.preventDefault();
          break;
        default:
          if (Mi(y) && y.length === 1) {
            let x = v + y.toLowerCase();
            a({
              type: yr,
              payload: x
            });
          }
          break;
      }
  }, ns(Ut, {
    currentIndex: f,
    orientation: "vertical",
    rotate: !1,
    filter: (h) => !h.disabled,
    callback: (h) => {
      a({
        type: ve,
        payload: {
          index: h,
          dropdownRef: s
        }
      });
    },
    key: "index"
  }));
  return {
    data: {
      activeDescendant: fa(f) || void 0,
      triggerId: d
    },
    props: {
      tabIndex: -1,
      ...n,
      ref: M,
      id: l,
      onKeyDown: J(t, m)
    }
  };
}
var fs = react.forwardRef(({ as: e = "div", ...t }, r) => {
  let { props: n } = ca({ ...t, ref: r });
  return /* @__PURE__ */ react.createElement(e, {
    "data-reach-dropdown-items": "",
    ...n
  });
});
fs.displayName = "DropdownItems";
function la({
  onBlur: e,
  portal: t = !0,
  position: r,
  ref: n,
  ...a
}) {
  let {
    triggerRef: i,
    triggerClickedRef: s,
    dispatch: u,
    dropdownRef: l,
    popoverRef: c,
    state: { isExpanded: d }
  } = yt("useDropdownPopover"), f = gt(c, n);
  return react.useEffect(() => {
    if (!d)
      return;
    let v = at(c.current);
    function p(M) {
      s.current ? s.current = !1 : ps(c.current, M.target) || u({ type: st });
    }
    return v.addEventListener("mousedown", p), () => {
      v.removeEventListener("mousedown", p);
    };
  }, [
    s,
    i,
    u,
    l,
    c,
    d
  ]), {
    data: {
      portal: t,
      position: r,
      targetRef: i,
      isExpanded: d
    },
    props: {
      ref: f,
      hidden: !d,
      onBlur: J(e, (v) => {
        v.currentTarget.contains(v.relatedTarget) || u({ type: st });
      }),
      ...a
    }
  };
}
var ds = react.forwardRef(({ as: e = "div", ...t }, r) => {
  let {
    data: { portal: n, targetRef: a, position: i },
    props: s
  } = la({ ...t, ref: r }), u = {
    "data-reach-dropdown-popover": ""
  };
  return n ? /* @__PURE__ */ react.createElement(Cr, {
    ...s,
    ...u,
    as: e,
    targetRef: a,
    position: i,
    unstable_skipInitialPortalRender: !0
  }) : /* @__PURE__ */ react.createElement(e, {
    ...s,
    ...u
  });
});
ds.displayName = "DropdownPopover";
function hs(e, t = "") {
  if (!t)
    return null;
  let r = e.find((n) => {
    var a, i, s;
    return n.disabled ? !1 : (s = (i = (a = n.element) == null ? void 0 : a.dataset) == null ? void 0 : i.valuetext) == null ? void 0 : s.toLowerCase().startsWith(t);
  });
  return r ? e.indexOf(r) : null;
}
function fa(e) {
  let { dropdownId: t } = yt("useItemId");
  return e != null && e > -1 ? Ct(`option-${e}`, t) : void 0;
}
function Rt(e) {
  e && e.focus();
}
function ps(e, t) {
  return !!(e && e.contains(t));
}
function ms(e, t = {}) {
  switch (t.type) {
    case Rr:
      return {
        ...e,
        isExpanded: !1,
        selectionIndex: -1
      };
    case st:
      return {
        ...e,
        isExpanded: !1,
        selectionIndex: -1
      };
    case ss:
      return {
        ...e,
        isExpanded: !0,
        selectionIndex: 0
      };
    case gr:
      return {
        ...e,
        isExpanded: !0,
        selectionIndex: t.payload.index
      };
    case ia:
      return {
        ...e,
        isExpanded: !0,
        selectionIndex: -1
      };
    case ve: {
      let { dropdownRef: r = { current: null } } = t.payload;
      if (t.payload.index >= 0 && t.payload.index !== e.selectionIndex) {
        if (r.current) {
          let n = at(r.current);
          r.current !== (n == null ? void 0 : n.activeElement) && r.current.focus();
        }
        return {
          ...e,
          selectionIndex: t.payload.max != null ? Math.min(Math.max(t.payload.index, 0), t.payload.max) : Math.max(t.payload.index, 0)
        };
      }
      return e;
    }
    case aa:
      return {
        ...e,
        selectionIndex: -1
      };
    case vr:
      return {
        ...e,
        triggerId: t.payload
      };
    case yr:
      return typeof t.payload < "u" ? {
        ...e,
        typeaheadQuery: t.payload
      } : e;
    default:
      return e;
  }
}
function da() {
  return ts(Ut);
}
var br = { exports: {} }, P = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vn;
function gs() {
  if (vn)
    return P;
  vn = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, M = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
  function h(y) {
    if (typeof y == "object" && y !== null) {
      var k = y.$$typeof;
      switch (k) {
        case t:
          switch (y = y.type, y) {
            case l:
            case c:
            case n:
            case i:
            case a:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case u:
                case d:
                case M:
                case p:
                case s:
                  return y;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  function S(y) {
    return h(y) === c;
  }
  return P.AsyncMode = l, P.ConcurrentMode = c, P.ContextConsumer = u, P.ContextProvider = s, P.Element = t, P.ForwardRef = d, P.Fragment = n, P.Lazy = M, P.Memo = p, P.Portal = r, P.Profiler = i, P.StrictMode = a, P.Suspense = f, P.isAsyncMode = function(y) {
    return S(y) || h(y) === l;
  }, P.isConcurrentMode = S, P.isContextConsumer = function(y) {
    return h(y) === u;
  }, P.isContextProvider = function(y) {
    return h(y) === s;
  }, P.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, P.isForwardRef = function(y) {
    return h(y) === d;
  }, P.isFragment = function(y) {
    return h(y) === n;
  }, P.isLazy = function(y) {
    return h(y) === M;
  }, P.isMemo = function(y) {
    return h(y) === p;
  }, P.isPortal = function(y) {
    return h(y) === r;
  }, P.isProfiler = function(y) {
    return h(y) === i;
  }, P.isStrictMode = function(y) {
    return h(y) === a;
  }, P.isSuspense = function(y) {
    return h(y) === f;
  }, P.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === c || y === i || y === a || y === f || y === v || typeof y == "object" && y !== null && (y.$$typeof === M || y.$$typeof === p || y.$$typeof === s || y.$$typeof === u || y.$$typeof === d || y.$$typeof === N || y.$$typeof === I || y.$$typeof === m || y.$$typeof === w);
  }, P.typeOf = h, P;
}
 br.exports = gs() ;
var vs = br.exports, ha = react.forwardRef(({ as: e = react.Fragment, id: t, children: r, ...n }, a) => {
  let s = react.useMemo(() => {
    try {
      return vs.isFragment(/* @__PURE__ */ react.createElement(e, null));
    } catch {
      return !1;
    }
  }, [e]) ? {} : {
    ref: a,
    id: t,
    "data-reach-menu": "",
    ...n
  };
  return /* @__PURE__ */ react.createElement(e, {
    ...s
  }, /* @__PURE__ */ react.createElement(sa, {
    id: t,
    children: r
  }));
});
ha.displayName = "Menu";
var pa = react.forwardRef(({ as: e = "button", ...t }, r) => {
  let {
    data: { isExpanded: n, controls: a },
    props: i
  } = oa({ ...t, ref: r });
  return /* @__PURE__ */ react.createElement(e, {
    "aria-expanded": n ? !0 : void 0,
    "aria-haspopup": !0,
    "aria-controls": a,
    ...i,
    "data-reach-menu-button": ""
  });
});
pa.displayName = "MenuButton";
var Or = react.forwardRef(({ as: e = "div", ...t }, r) => {
  let {
    data: { disabled: n },
    props: a
  } = ua({ ...t, ref: r });
  return /* @__PURE__ */ react.createElement(e, {
    role: "menuitem",
    ...a,
    "aria-disabled": n || void 0,
    "data-reach-menu-item": ""
  });
});
Or.displayName = "MenuItemImpl";
var ma = react.forwardRef(({ as: e = "div", ...t }, r) => /* @__PURE__ */ react.createElement(Or, {
  ...t,
  ref: r,
  as: e
}));
ma.displayName = "MenuItem";
var ga = react.forwardRef(({ as: e = "div", ...t }, r) => {
  let {
    data: { activeDescendant: n, triggerId: a },
    props: i
  } = ca({ ...t, ref: r });
  return /* @__PURE__ */ react.createElement(e, {
    "aria-activedescendant": n,
    "aria-labelledby": a || void 0,
    role: "menu",
    ...i,
    "data-reach-menu-items": ""
  });
});
ga.displayName = "MenuItems";
var bs = react.forwardRef(({
  as: e = "a",
  component: t,
  onSelect: r,
  ...n
}, a) => (react.useEffect(() => {
  t && console.warn("[@reach/menu-button]: Please use the `as` prop instead of `component`");
}, [t]), /* @__PURE__ */ react.createElement(Or, {
  ...n,
  ref: a,
  "data-reach-menu-link": "",
  as: e,
  isLink: !0,
  onSelect: r || Ar
})));
bs.displayName = "MenuLink";
var ya = react.forwardRef(({ portal: e = !0, ...t }, r) => /* @__PURE__ */ react.createElement(va, {
  portal: e
}, /* @__PURE__ */ react.createElement(ga, {
  ...t,
  ref: r,
  "data-reach-menu-list": ""
})));
ya.displayName = "MenuList";
var va = react.forwardRef(({ as: e = "div", ...t }, r) => {
  let {
    data: { portal: n, targetRef: a, position: i },
    props: s
  } = la({ ...t, ref: r }), u = {
    "data-reach-menu-popover": ""
  };
  return n ? /* @__PURE__ */ react.createElement(Cr, {
    ...s,
    ...u,
    as: e,
    targetRef: a,
    position: i,
    unstable_skipInitialPortalRender: !0
  }) : /* @__PURE__ */ react.createElement(e, {
    ...s,
    ...u
  });
});
va.displayName = "MenuPopover";
const Es = "data:image/svg+xml;base64,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", Ms = "data:image/svg+xml;base64,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", Er = { EN: "en", DA: "da" }, ws = {
  [Er.EN]: "English",
  [Er.DA]: "Dansk"
};
function Ko({
  current: e,
  onSelect: t
}) {
  const r = Object.keys(ws).filter(
    (n) => n !== e
  );
  return /* @__PURE__ */ V.jsxs(ha, { children: [
    /* @__PURE__ */ V.jsx("div", { children: /* @__PURE__ */ V.jsx(
      "img",
      {
        src: e === Er.EN ? Es : Ms,
        alt: "",
        style: { width: "16px", height: "16px" }
      }
    ) }),
    /* @__PURE__ */ V.jsxs(pa, { "data-ticketbutler-language-selector": "", children: [
      /* @__PURE__ */ V.jsx("span", { "data-ticketbutler-language-selector-code": "", children: e }),
      " ",
      /* @__PURE__ */ V.jsx("span", { "aria-hidden": !0, children: "▾" })
    ] }),
    /* @__PURE__ */ V.jsx(ya, { "data-ticketbutler-language-selector-list": "", children: r.map(function(n) {
      return /* @__PURE__ */ V.jsx(
        ma,
        {
          onSelect: function() {
            t(n);
          },
          children: /* @__PURE__ */ V.jsx("span", { "data-ticketbutler-language-selector-code": "", children: n })
        },
        n
      );
    }) })
  ] });
}
var Is = Object.defineProperty, Ts = (e, t) => {
  for (var r in t)
    Is(e, r, { get: t[r], enumerable: !0 });
}, se = {};
Ts(se, {
  assign: () => _s,
  colors: () => Me,
  createStringInterpolator: () => Ur,
  skipAnimation: () => Na,
  to: () => Ta,
  willAdvance: () => Qr
});
var Pr = bt(), j = (e) => vt(e, Pr), Lr = bt();
j.write = (e) => vt(e, Lr);
var Qt = bt();
j.onStart = (e) => vt(e, Qt);
var kr = bt();
j.onFrame = (e) => vt(e, kr);
var zr = bt();
j.onFinish = (e) => vt(e, zr);
var Qe = [];
j.setTimeout = (e, t) => {
  const r = j.now() + t, n = () => {
    const i = Qe.findIndex((s) => s.cancel == n);
    ~i && Qe.splice(i, 1), Ee -= ~i ? 1 : 0;
  }, a = { time: r, handler: e, cancel: n };
  return Qe.splice(ba(r), 0, a), Ee += 1, Ea(), a;
};
var ba = (e) => ~(~Qe.findIndex((t) => t.time > e) || ~Qe.length);
j.cancel = (e) => {
  Qt.delete(e), kr.delete(e), zr.delete(e), Pr.delete(e), Lr.delete(e);
};
j.sync = (e) => {
  Mr = !0, j.batchedUpdates(e), Mr = !1;
};
j.throttle = (e) => {
  let t;
  function r() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function n(...a) {
    t = a, j.onStart(r);
  }
  return n.handler = e, n.cancel = () => {
    Qt.delete(r), t = null;
  }, n;
};
var Yr = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
j.use = (e) => Yr = e;
j.now = typeof performance < "u" ? () => performance.now() : Date.now;
j.batchedUpdates = (e) => e();
j.catch = console.error;
j.frameLoop = "always";
j.advance = () => {
  j.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : wa();
};
var be = -1, Ee = 0, Mr = !1;
function vt(e, t) {
  Mr ? (t.delete(e), e(0)) : (t.add(e), Ea());
}
function Ea() {
  be < 0 && (be = 0, j.frameLoop !== "demand" && Yr(Ma));
}
function Ns() {
  be = -1;
}
function Ma() {
  ~be && (Yr(Ma), j.batchedUpdates(wa));
}
function wa() {
  const e = be;
  be = j.now();
  const t = ba(be);
  if (t && (Ia(Qe.splice(0, t), (r) => r.handler()), Ee -= t), !Ee) {
    Ns();
    return;
  }
  Qt.flush(), Pr.flush(e ? Math.min(64, be - e) : 16.667), kr.flush(), Lr.flush(), zr.flush();
}
function bt() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(r) {
      Ee += t == e && !e.has(r) ? 1 : 0, e.add(r);
    },
    delete(r) {
      return Ee -= t == e && e.has(r) ? 1 : 0, e.delete(r);
    },
    flush(r) {
      t.size && (e = /* @__PURE__ */ new Set(), Ee -= t.size, Ia(t, (n) => n(r) && e.add(n)), Ee += e.size, t = e);
    }
  };
}
function Ia(e, t) {
  e.forEach((r) => {
    try {
      t(r);
    } catch (n) {
      j.catch(n);
    }
  });
}
function wr() {
}
var Ss = (e, t, r) => Object.defineProperty(e, t, { value: r, writable: !0, configurable: !0 }), E = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function he(e, t) {
  if (E.arr(e)) {
    if (!E.arr(t) || e.length !== t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (e[r] !== t[r])
        return !1;
    return !0;
  }
  return e === t;
}
var C = (e, t) => e.forEach(t);
function ue(e, t, r) {
  if (E.arr(e)) {
    for (let n = 0; n < e.length; n++)
      t.call(r, e[n], `${n}`);
    return;
  }
  for (const n in e)
    e.hasOwnProperty(n) && t.call(r, e[n], n);
}
var ee = (e) => E.und(e) ? [] : E.arr(e) ? e : [e];
function et(e, t) {
  if (e.size) {
    const r = Array.from(e);
    e.clear(), C(r, t);
  }
}
var Je = (e, ...t) => et(e, (r) => r(...t)), Fr = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), Ur, Ta, Me = null, Na = !1, Qr = wr, _s = (e) => {
  e.to && (Ta = e.to), e.now && (j.now = e.now), e.colors !== void 0 && (Me = e.colors), e.skipAnimation != null && (Na = e.skipAnimation), e.createStringInterpolator && (Ur = e.createStringInterpolator), e.requestAnimationFrame && j.use(e.requestAnimationFrame), e.batchedUpdates && (j.batchedUpdates = e.batchedUpdates), e.willAdvance && (Qr = e.willAdvance), e.frameLoop && (j.frameLoop = e.frameLoop);
}, tt = /* @__PURE__ */ new Set(), re = [], sr = [], Ot = 0, $t = {
  get idle() {
    return !tt.size && !re.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    Ot > e.priority ? (tt.add(e), j.onStart(Ds)) : (Sa(e), j(Ir));
  },
  /** Advance all animations by the given time. */
  advance: Ir,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (Ot)
      j.onFrame(() => $t.sort(e));
    else {
      const t = re.indexOf(e);
      ~t && (re.splice(t, 1), _a(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    re = [], tt.clear();
  }
};
function Ds() {
  tt.forEach(Sa), tt.clear(), j(Ir);
}
function Sa(e) {
  re.includes(e) || _a(e);
}
function _a(e) {
  re.splice(
    xs(re, (t) => t.priority > e.priority),
    0,
    e
  );
}
function Ir(e) {
  const t = sr;
  for (let r = 0; r < re.length; r++) {
    const n = re[r];
    Ot = n.priority, n.idle || (Qr(n), n.advance(e), n.idle || t.push(n));
  }
  return Ot = 0, sr = re, sr.length = 0, re = t, re.length > 0;
}
function xs(e, t) {
  const r = e.findIndex(t);
  return r < 0 ? e.length : r;
}
var js = (e, t, r) => Math.min(Math.max(r, e), t), As = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, ie = "[-+]?\\d*\\.?\\d+", Pt = ie + "%";
function Vt(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var Cs = new RegExp("rgb" + Vt(ie, ie, ie)), Rs = new RegExp("rgba" + Vt(ie, ie, ie, ie)), Os = new RegExp("hsl" + Vt(ie, Pt, Pt)), Ps = new RegExp(
  "hsla" + Vt(ie, Pt, Pt, ie)
), Ls = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, ks = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, zs = /^#([0-9a-fA-F]{6})$/, Ys = /^#([0-9a-fA-F]{8})$/;
function Fs(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = zs.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : Me && Me[e] !== void 0 ? Me[e] : (t = Cs.exec(e)) ? (Fe(t[1]) << 24 | // r
  Fe(t[2]) << 16 | // g
  Fe(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = Rs.exec(e)) ? (Fe(t[1]) << 24 | // r
  Fe(t[2]) << 16 | // g
  Fe(t[3]) << 8 | // b
  wn(t[4])) >>> // a
  0 : (t = Ls.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = Ys.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = ks.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = Os.exec(e)) ? (En(
    Mn(t[1]),
    // h
    It(t[2]),
    // s
    It(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = Ps.exec(e)) ? (En(
    Mn(t[1]),
    // h
    It(t[2]),
    // s
    It(t[3])
    // l
  ) | wn(t[4])) >>> // a
  0 : null;
}
function or(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * 6 * r : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function En(e, t, r) {
  const n = r < 0.5 ? r * (1 + t) : r + t - r * t, a = 2 * r - n, i = or(a, n, e + 1 / 3), s = or(a, n, e), u = or(a, n, e - 1 / 3);
  return Math.round(i * 255) << 24 | Math.round(s * 255) << 16 | Math.round(u * 255) << 8;
}
function Fe(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function Mn(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function wn(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function It(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function In(e) {
  let t = Fs(e);
  if (t === null)
    return e;
  t = t || 0;
  const r = (t & 4278190080) >>> 24, n = (t & 16711680) >>> 16, a = (t & 65280) >>> 8, i = (t & 255) / 255;
  return `rgba(${r}, ${n}, ${a}, ${i})`;
}
var ot = (e, t, r) => {
  if (E.fun(e))
    return e;
  if (E.arr(e))
    return ot({
      range: e,
      output: t,
      extrapolate: r
    });
  if (E.str(e.output[0]))
    return Ur(e);
  const n = e, a = n.output, i = n.range || [0, 1], s = n.extrapolateLeft || n.extrapolate || "extend", u = n.extrapolateRight || n.extrapolate || "extend", l = n.easing || ((c) => c);
  return (c) => {
    const d = Qs(c, i);
    return Us(
      c,
      i[d],
      i[d + 1],
      a[d],
      a[d + 1],
      l,
      s,
      u,
      n.map
    );
  };
};
function Us(e, t, r, n, a, i, s, u, l) {
  let c = l ? l(e) : e;
  if (c < t) {
    if (s === "identity")
      return c;
    s === "clamp" && (c = t);
  }
  if (c > r) {
    if (u === "identity")
      return c;
    u === "clamp" && (c = r);
  }
  return n === a ? n : t === r ? e <= t ? n : a : (t === -1 / 0 ? c = -c : r === 1 / 0 ? c = c - t : c = (c - t) / (r - t), c = i(c), n === -1 / 0 ? c = -c : a === 1 / 0 ? c = c + n : c = c * (a - n) + n, c);
}
function Qs(e, t) {
  for (var r = 1; r < t.length - 1 && !(t[r] >= e); ++r)
    ;
  return r - 1;
}
var $s = (e, t = "end") => (r) => {
  r = t === "end" ? Math.min(r, 0.999) : Math.max(r, 1e-3);
  const n = r * e, a = t === "end" ? Math.floor(n) : Math.ceil(n);
  return js(0, 1, a / e);
}, Lt = 1.70158, Tt = Lt * 1.525, Tn = Lt + 1, Nn = 2 * Math.PI / 3, Sn = 2 * Math.PI / 4.5, Nt = (e) => e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375, Vs = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => 1 - (1 - e) * (1 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => 1 - Math.pow(1 - e, 3),
  easeInOutCubic: (e) => e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => 1 - Math.pow(1 - e, 4),
  easeInOutQuart: (e) => e < 0.5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => 1 - Math.pow(1 - e, 5),
  easeInOutQuint: (e) => e < 0.5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
  easeInSine: (e) => 1 - Math.cos(e * Math.PI / 2),
  easeOutSine: (e) => Math.sin(e * Math.PI / 2),
  easeInOutSine: (e) => -(Math.cos(Math.PI * e) - 1) / 2,
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * e - 10),
  easeOutExpo: (e) => e === 1 ? 1 : 1 - Math.pow(2, -10 * e),
  easeInOutExpo: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
  easeInCirc: (e) => 1 - Math.sqrt(1 - Math.pow(e, 2)),
  easeOutCirc: (e) => Math.sqrt(1 - Math.pow(e - 1, 2)),
  easeInOutCirc: (e) => e < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
  easeInBack: (e) => Tn * e * e * e - Lt * e * e,
  easeOutBack: (e) => 1 + Tn * Math.pow(e - 1, 3) + Lt * Math.pow(e - 1, 2),
  easeInOutBack: (e) => e < 0.5 ? Math.pow(2 * e, 2) * ((Tt + 1) * 2 * e - Tt) / 2 : (Math.pow(2 * e - 2, 2) * ((Tt + 1) * (e * 2 - 2) + Tt) + 2) / 2,
  easeInElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((e * 10 - 10.75) * Nn),
  easeOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e * 10 - 0.75) * Nn) + 1,
  easeInOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? -(Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * Sn)) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * Sn) / 2 + 1,
  easeInBounce: (e) => 1 - Nt(1 - e),
  easeOutBounce: Nt,
  easeInOutBounce: (e) => e < 0.5 ? (1 - Nt(1 - 2 * e)) / 2 : (1 + Nt(2 * e - 1)) / 2,
  steps: $s
}, ut = Symbol.for("FluidValue.get"), Ve = Symbol.for("FluidValue.observers"), te = (e) => !!(e && e[ut]), X = (e) => e && e[ut] ? e[ut]() : e, _n = (e) => e[Ve] || null;
function Bs(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function ct(e, t) {
  const r = e[Ve];
  r && r.forEach((n) => {
    Bs(n, t);
  });
}
var Da = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    Ws(this, e);
  }
}, Ws = (e, t) => xa(e, ut, t);
function Be(e, t) {
  if (e[ut]) {
    let r = e[Ve];
    r || xa(e, Ve, r = /* @__PURE__ */ new Set()), r.has(t) || (r.add(t), e.observerAdded && e.observerAdded(r.size, t));
  }
  return t;
}
function lt(e, t) {
  const r = e[Ve];
  if (r && r.has(t)) {
    const n = r.size - 1;
    n ? r.delete(t) : e[Ve] = null, e.observerRemoved && e.observerRemoved(n, t);
  }
}
var xa = (e, t, r) => Object.defineProperty(e, t, {
  value: r,
  writable: !0,
  configurable: !0
}), xt = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, qs = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, Dn = new RegExp(`(${xt.source})(%|[a-z]+)`, "i"), Gs = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, Bt = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, ja = (e) => {
  const [t, r] = Zs(e);
  if (!t || Fr())
    return e;
  const n = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (n)
    return n.trim();
  if (r && r.startsWith("--")) {
    const a = window.getComputedStyle(document.documentElement).getPropertyValue(r);
    return a || e;
  } else {
    if (r && Bt.test(r))
      return ja(r);
    if (r)
      return r;
  }
  return e;
}, Zs = (e) => {
  const t = Bt.exec(e);
  if (!t)
    return [,];
  const [, r, n] = t;
  return [r, n];
}, ur, Xs = (e, t, r, n, a) => `rgba(${Math.round(t)}, ${Math.round(r)}, ${Math.round(n)}, ${a})`, Aa = (e) => {
  ur || (ur = Me ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(Me).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((i) => X(i).replace(Bt, ja).replace(qs, In).replace(ur, In)), r = t.map((i) => i.match(xt).map(Number)), a = r[0].map(
    (i, s) => r.map((u) => {
      if (!(s in u))
        throw Error('The arity of each "output" value must be equal');
      return u[s];
    })
  ).map(
    (i) => ot({ ...e, output: i })
  );
  return (i) => {
    var l;
    const s = !Dn.test(t[0]) && ((l = t.find((c) => Dn.test(c))) == null ? void 0 : l.replace(xt, ""));
    let u = 0;
    return t[0].replace(
      xt,
      () => `${a[u++](i)}${s || ""}`
    ).replace(Gs, Xs);
  };
}, $r = "react-spring: ", Ca = (e) => {
  const t = e;
  let r = !1;
  if (typeof t != "function")
    throw new TypeError(`${$r}once requires a function parameter`);
  return (...n) => {
    r || (t(...n), r = !0);
  };
}, Hs = Ca(console.warn);
function Ks() {
  Hs(
    `${$r}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var Js = Ca(console.warn);
function eo() {
  Js(
    `${$r}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function Wt(e) {
  return E.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !Fr() && Bt.test(e) || e in (Me || {}));
}
var Vr = Fr() ? react.useEffect : react.useLayoutEffect, to = () => {
  const e = react.useRef(!1);
  return Vr(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function Ra() {
  const e = react.useState()[1], t = to();
  return () => {
    t.current && e(Math.random());
  };
}
function ro(e, t) {
  const [r] = react.useState(
    () => ({
      inputs: t,
      result: e()
    })
  ), n = react.useRef(), a = n.current;
  let i = a;
  return i ? t && i.inputs && no(t, i.inputs) || (i = {
    inputs: t,
    result: e()
  }) : i = r, react.useEffect(() => {
    n.current = i, a == r && (r.inputs = r.result = void 0);
  }, [i]), i.result;
}
function no(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var Oa = (e) => react.useEffect(e, ao), ao = [];
function xn(e) {
  const t = react.useRef();
  return react.useEffect(() => {
    t.current = e;
  }), t.current;
}
var ft = Symbol.for("Animated:node"), io = (e) => !!e && e[ft] === e, oe = (e) => e && e[ft], Br = (e, t) => Ss(e, ft, t), qt = (e) => e && e[ft] && e[ft].getPayload(), Pa = class {
  constructor() {
    Br(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, Et = class extends Pa {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, E.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new Et(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return E.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, E.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, dt = class extends Et {
  constructor(e) {
    super(0), this._string = null, this._toString = ot({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new dt(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (E.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = ot({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, kt = { dependencies: null }, Gt = class extends Pa {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return ue(this.source, (r, n) => {
      io(r) ? t[n] = r.getValue(e) : te(r) ? t[n] = X(r) : e || (t[n] = r);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && C(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return ue(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    kt.dependencies && te(e) && kt.dependencies.add(e);
    const t = qt(e);
    t && C(t, (r) => this.add(r));
  }
}, La = class extends Gt {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new La(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((r, n) => r.setValue(e[n])).some(Boolean) : (super.setValue(e.map(so)), !0);
  }
};
function so(e) {
  return (Wt(e) ? dt : Et).create(e);
}
function Tr(e) {
  const t = oe(e);
  return t ? t.constructor : E.arr(e) ? La : Wt(e) ? dt : Et;
}
var jn = (e, t) => {
  const r = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !E.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return react.forwardRef((n, a) => {
    const i = react.useRef(null), s = r && // eslint-disable-next-line react-hooks/rules-of-hooks
    react.useCallback(
      (M) => {
        i.current = co(a, M);
      },
      [a]
    ), [u, l] = uo(n, t), c = Ra(), d = () => {
      const M = i.current;
      if (r && !M)
        return;
      (M ? t.applyAnimatedValues(M, u.getValue(!0)) : !1) === !1 && c();
    }, f = new oo(d, l), v = react.useRef();
    Vr(() => (v.current = f, C(l, (M) => Be(M, f)), () => {
      v.current && (C(
        v.current.deps,
        (M) => lt(M, v.current)
      ), j.cancel(v.current.update));
    })), react.useEffect(d, []), Oa(() => () => {
      const M = v.current;
      C(M.deps, (w) => lt(w, M));
    });
    const p = t.getComponentProps(u.getValue());
    return /* @__PURE__ */ react.createElement(e, { ...p, ref: s });
  });
}, oo = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && j.write(this.update);
  }
};
function uo(e, t) {
  const r = /* @__PURE__ */ new Set();
  return kt.dependencies = r, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new Gt(e), kt.dependencies = null, [e, r];
}
function co(e, t) {
  return e && (E.fun(e) ? e(t) : e.current = t), t;
}
var An = Symbol.for("AnimatedComponent"), lo = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: r = (a) => new Gt(a),
  getComponentProps: n = (a) => a
} = {}) => {
  const a = {
    applyAnimatedValues: t,
    createAnimatedStyle: r,
    getComponentProps: n
  }, i = (s) => {
    const u = Cn(s) || "Anonymous";
    return E.str(s) ? s = i[s] || (i[s] = jn(s, a)) : s = s[An] || (s[An] = jn(s, a)), s.displayName = `Animated(${u})`, s;
  };
  return ue(e, (s, u) => {
    E.arr(e) && (u = Cn(s)), i[u] = i(s);
  }), {
    animated: i
  };
}, Cn = (e) => E.str(e) ? e : e && E.str(e.displayName) ? e.displayName : E.fun(e) && e.name || null;
function _e(e, ...t) {
  return E.fun(e) ? e(...t) : e;
}
var rt = (e, t) => e === !0 || !!(t && e && (E.fun(e) ? e(t) : ee(e).includes(t))), ka = (e, t) => E.obj(e) ? t && e[t] : e, za = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, fo = (e) => e, Wr = (e, t = fo) => {
  let r = ho;
  e.default && e.default !== !0 && (e = e.default, r = Object.keys(e));
  const n = {};
  for (const a of r) {
    const i = t(e[a], a);
    E.und(i) || (n[a] = i);
  }
  return n;
}, ho = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], po = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function mo(e) {
  const t = {};
  let r = 0;
  if (ue(e, (n, a) => {
    po[a] || (t[a] = n, r++);
  }), r)
    return t;
}
function Ya(e) {
  const t = mo(e);
  if (t) {
    const r = { to: t };
    return ue(e, (n, a) => a in t || (r[a] = n)), r;
  }
  return { ...e };
}
function ht(e) {
  return e = X(e), E.arr(e) ? e.map(ht) : Wt(e) ? se.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function go(e) {
  for (const t in e)
    return !0;
  return !1;
}
function Nr(e) {
  return E.fun(e) || E.arr(e) && E.obj(e[0]);
}
function yo(e, t) {
  var r;
  (r = e.ref) == null || r.delete(e), t == null || t.delete(e);
}
function vo(e, t) {
  var r;
  t && e.ref !== t && ((r = e.ref) == null || r.delete(e), t.add(e), e.ref = t);
}
var bo = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, Sr = {
  ...bo.default,
  mass: 1,
  damping: 1,
  easing: Vs.linear,
  clamp: !1
}, Eo = class {
  constructor() {
    this.velocity = 0, Object.assign(this, Sr);
  }
};
function Mo(e, t, r) {
  r && (r = { ...r }, Rn(r, t), t = { ...r, ...t }), Rn(e, t), Object.assign(e, t);
  for (const s in Sr)
    e[s] == null && (e[s] = Sr[s]);
  let { frequency: n, damping: a } = e;
  const { mass: i } = e;
  return E.und(n) || (n < 0.01 && (n = 0.01), a < 0 && (a = 0), e.tension = Math.pow(2 * Math.PI / n, 2) * i, e.friction = 4 * Math.PI * a * i / n), e;
}
function Rn(e, t) {
  if (!E.und(t.decay))
    e.duration = void 0;
  else {
    const r = !E.und(t.tension) || !E.und(t.friction);
    (r || !E.und(t.frequency) || !E.und(t.damping) || !E.und(t.mass)) && (e.duration = void 0, e.decay = void 0), r && (e.frequency = void 0);
  }
}
var On = [], wo = class {
  constructor() {
    this.changed = !1, this.values = On, this.toValues = null, this.fromValues = On, this.config = new Eo(), this.immediate = !1;
  }
};
function Fa(e, { key: t, props: r, defaultProps: n, state: a, actions: i }) {
  return new Promise((s, u) => {
    let l, c, d = rt(r.cancel ?? (n == null ? void 0 : n.cancel), t);
    if (d)
      p();
    else {
      E.und(r.pause) || (a.paused = rt(r.pause, t));
      let M = n == null ? void 0 : n.pause;
      M !== !0 && (M = a.paused || rt(M, t)), l = _e(r.delay || 0, t), M ? (a.resumeQueue.add(v), i.pause()) : (i.resume(), v());
    }
    function f() {
      a.resumeQueue.add(v), a.timeouts.delete(c), c.cancel(), l = c.time - j.now();
    }
    function v() {
      l > 0 && !se.skipAnimation ? (a.delayed = !0, c = j.setTimeout(p, l), a.pauseQueue.add(f), a.timeouts.add(c)) : p();
    }
    function p() {
      a.delayed && (a.delayed = !1), a.pauseQueue.delete(f), a.timeouts.delete(c), e <= (a.cancelId || 0) && (d = !0);
      try {
        i.start({ ...r, callId: e, cancel: d }, s);
      } catch (M) {
        u(M);
      }
    }
  });
}
var qr = (e, t) => t.length == 1 ? t[0] : t.some((r) => r.cancelled) ? $e(e.get()) : t.every((r) => r.noop) ? Ua(e.get()) : ae(
  e.get(),
  t.every((r) => r.finished)
), Ua = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), ae = (e, t, r = !1) => ({
  value: e,
  finished: t,
  cancelled: r
}), $e = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function Qa(e, t, r, n) {
  const { callId: a, parentId: i, onRest: s } = t, { asyncTo: u, promise: l } = r;
  return !i && e === u && !t.reset ? l : r.promise = (async () => {
    r.asyncId = a, r.asyncTo = e;
    const c = Wr(
      t,
      (N, I) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        I === "onRest" ? void 0 : N
      )
    );
    let d, f;
    const v = new Promise(
      (N, I) => (d = N, f = I)
    ), p = (N) => {
      const I = (
        // The `cancel` prop or `stop` method was used.
        a <= (r.cancelId || 0) && $e(n) || // The async `to` prop was replaced.
        a !== r.asyncId && ae(n, !1)
      );
      if (I)
        throw N.result = I, f(N), N;
    }, M = (N, I) => {
      const m = new Pn(), h = new Ln();
      return (async () => {
        if (se.skipAnimation)
          throw pt(r), h.result = ae(n, !1), f(h), h;
        p(m);
        const S = E.obj(N) ? { ...N } : { ...I, to: N };
        S.parentId = a, ue(c, (k, x) => {
          E.und(S[x]) && (S[x] = k);
        });
        const y = await n.start(S);
        return p(m), r.paused && await new Promise((k) => {
          r.resumeQueue.add(k);
        }), y;
      })();
    };
    let w;
    if (se.skipAnimation)
      return pt(r), ae(n, !1);
    try {
      let N;
      E.arr(e) ? N = (async (I) => {
        for (const m of I)
          await M(m);
      })(e) : N = Promise.resolve(e(M, n.stop.bind(n))), await Promise.all([N.then(d), v]), w = ae(n.get(), !0, !1);
    } catch (N) {
      if (N instanceof Pn)
        w = N.result;
      else if (N instanceof Ln)
        w = N.result;
      else
        throw N;
    } finally {
      a == r.asyncId && (r.asyncId = i, r.asyncTo = i ? u : void 0, r.promise = i ? l : void 0);
    }
    return E.fun(s) && j.batchedUpdates(() => {
      s(w, n, n.item);
    }), w;
  })();
}
function pt(e, t) {
  et(e.timeouts, (r) => r.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var Pn = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, Ln = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, _r = (e) => e instanceof Gr, Io = 1, Gr = class extends Da {
  constructor() {
    super(...arguments), this.id = Io++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = oe(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return se.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return Ks(), se.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    ct(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || $t.sort(this), ct(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, De = Symbol.for("SpringPhase"), $a = 1, Dr = 2, xr = 4, cr = (e) => (e[De] & $a) > 0, ge = (e) => (e[De] & Dr) > 0, Ze = (e) => (e[De] & xr) > 0, kn = (e, t) => t ? e[De] |= Dr | $a : e[De] &= ~Dr, zn = (e, t) => t ? e[De] |= xr : e[De] &= ~xr, To = class extends Gr {
  constructor(e, t) {
    if (super(), this.animation = new wo(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !E.und(e) || !E.und(t)) {
      const r = E.obj(e) ? { ...e } : { ...t, from: e };
      E.und(r.default) && (r.default = !0), this.start(r);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(ge(this) || this._state.asyncTo) || Ze(this);
  }
  get goal() {
    return X(this.animation.to);
  }
  get velocity() {
    const e = oe(this);
    return e instanceof Et ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return cr(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return ge(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return Ze(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, r = !1;
    const n = this.animation;
    let { toValues: a } = n;
    const { config: i } = n, s = qt(n.to);
    !s && te(n.to) && (a = ee(X(n.to))), n.values.forEach((c, d) => {
      if (c.done)
        return;
      const f = (
        // Animated strings always go from 0 to 1.
        c.constructor == dt ? 1 : s ? s[d].lastPosition : a[d]
      );
      let v = n.immediate, p = f;
      if (!v) {
        if (p = c.lastPosition, i.tension <= 0) {
          c.done = !0;
          return;
        }
        let M = c.elapsedTime += e;
        const w = n.fromValues[d], N = c.v0 != null ? c.v0 : c.v0 = E.arr(i.velocity) ? i.velocity[d] : i.velocity;
        let I;
        const m = i.precision || (w == f ? 5e-3 : Math.min(1, Math.abs(f - w) * 1e-3));
        if (E.und(i.duration))
          if (i.decay) {
            const h = i.decay === !0 ? 0.998 : i.decay, S = Math.exp(-(1 - h) * M);
            p = w + N / (1 - h) * (1 - S), v = Math.abs(c.lastPosition - p) <= m, I = N * S;
          } else {
            I = c.lastVelocity == null ? N : c.lastVelocity;
            const h = i.restVelocity || m / 10, S = i.clamp ? 0 : i.bounce, y = !E.und(S), k = w == f ? c.v0 > 0 : w < f;
            let x, F = !1;
            const B = 1, ne = Math.ceil(e / B);
            for (let Q = 0; Q < ne && (x = Math.abs(I) > h, !(!x && (v = Math.abs(f - p) <= m, v))); ++Q) {
              y && (F = p == f || p > f == k, F && (I = -I * S, p = f));
              const H = -i.tension * 1e-6 * (p - f), K = -i.friction * 1e-3 * I, q = (H + K) / i.mass;
              I = I + q * B, p = p + I * B;
            }
          }
        else {
          let h = 1;
          i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, c.durationProgress > 0 && (c.elapsedTime = i.duration * c.durationProgress, M = c.elapsedTime += e)), h = (i.progress || 0) + M / this._memoizedDuration, h = h > 1 ? 1 : h < 0 ? 0 : h, c.durationProgress = h), p = w + i.easing(h) * (f - w), I = (p - c.lastPosition) / e, v = h == 1;
        }
        c.lastVelocity = I, Number.isNaN(p) && (console.warn("Got NaN while animating:", this), v = !0);
      }
      s && !s[d].done && (v = !1), v ? c.done = !0 : t = !1, c.setValue(p, i.round) && (r = !0);
    });
    const u = oe(this), l = u.getValue();
    if (t) {
      const c = X(n.to);
      (l !== c || r) && !i.decay ? (u.setValue(c), this._onChange(c)) : r && i.decay && this._onChange(l), this._stop();
    } else
      r && this._onChange(l);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return j.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (ge(this)) {
      const { to: e, config: t } = this.animation;
      j.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let r;
    return E.und(e) ? (r = this.queue || [], this.queue = []) : r = [E.obj(e) ? e : { ...t, to: e }], Promise.all(
      r.map((n) => this._update(n))
    ).then((n) => qr(this, n));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), pt(this._state, e && this._lastCallId), j.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: r, from: n } = e;
    r = E.obj(r) ? r[t] : r, (r == null || Nr(r)) && (r = void 0), n = E.obj(n) ? n[t] : n, n == null && (n = void 0);
    const a = { to: r, from: n };
    return cr(this) || (e.reverse && ([r, n] = [n, r]), n = X(n), E.und(n) ? oe(this) || this._set(r) : this._set(n)), a;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: r, defaultProps: n } = this;
    e.default && Object.assign(
      n,
      Wr(
        e,
        (s, u) => /^on/.test(u) ? ka(s, r) : s
      )
    ), Fn(this, e, "onProps"), He(this, "onProps", e, this);
    const a = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const i = this._state;
    return Fa(++this._lastCallId, {
      key: r,
      props: e,
      defaultProps: n,
      state: i,
      actions: {
        pause: () => {
          Ze(this) || (zn(this, !0), Je(i.pauseQueue), He(
            this,
            "onPause",
            ae(this, Xe(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          Ze(this) && (zn(this, !1), ge(this) && this._resume(), Je(i.resumeQueue), He(
            this,
            "onResume",
            ae(this, Xe(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, a)
      }
    }).then((s) => {
      if (e.loop && s.finished && !(t && s.noop)) {
        const u = Va(e);
        if (u)
          return this._update(u, !0);
      }
      return s;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, r) {
    if (t.cancel)
      return this.stop(!0), r($e(this));
    const n = !E.und(e.to), a = !E.und(e.from);
    if (n || a)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return r($e(this));
    const { key: i, defaultProps: s, animation: u } = this, { to: l, from: c } = u;
    let { to: d = l, from: f = c } = e;
    a && !n && (!t.default || E.und(d)) && (d = f), t.reverse && ([d, f] = [f, d]);
    const v = !he(f, c);
    v && (u.from = f), f = X(f);
    const p = !he(d, l);
    p && this._focus(d);
    const M = Nr(t.to), { config: w } = u, { decay: N, velocity: I } = w;
    (n || a) && (w.velocity = 0), t.config && !M && Mo(
      w,
      _e(t.config, i),
      // Avoid calling the same "config" prop twice.
      t.config !== s.config ? _e(s.config, i) : void 0
    );
    let m = oe(this);
    if (!m || E.und(d))
      return r(ae(this, !0));
    const h = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      E.und(t.reset) ? a && !t.default : !E.und(f) && rt(t.reset, i)
    ), S = h ? f : this.get(), y = ht(d), k = E.num(y) || E.arr(y) || Wt(y), x = !M && (!k || rt(s.immediate || t.immediate, i));
    if (p) {
      const Q = Tr(d);
      if (Q !== m.constructor)
        if (x)
          m = this._set(y);
        else
          throw Error(
            `Cannot animate between ${m.constructor.name} and ${Q.name}, as the "to" prop suggests`
          );
    }
    const F = m.constructor;
    let B = te(d), ne = !1;
    if (!B) {
      const Q = h || !cr(this) && v;
      (p || Q) && (ne = he(ht(S), y), B = !ne), (!he(u.immediate, x) && !x || !he(w.decay, N) || !he(w.velocity, I)) && (B = !0);
    }
    if (ne && ge(this) && (u.changed && !h ? B = !0 : B || this._stop(l)), !M && ((B || te(l)) && (u.values = m.getPayload(), u.toValues = te(d) ? null : F == dt ? [1] : ee(y)), u.immediate != x && (u.immediate = x, !x && !h && this._set(l)), B)) {
      const { onRest: Q } = u;
      C(So, (K) => Fn(this, t, K));
      const H = ae(this, Xe(this, l));
      Je(this._pendingCalls, H), this._pendingCalls.add(r), u.changed && j.batchedUpdates(() => {
        var K;
        u.changed = !h, Q == null || Q(H, this), h ? _e(s.onRest, H) : (K = u.onStart) == null || K.call(u, H, this);
      });
    }
    h && this._set(S), M ? r(Qa(t.to, t, this._state, this)) : B ? this._start() : ge(this) && !p ? this._pendingCalls.add(r) : r(Ua(S));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (_n(this) && this._detach(), t.to = e, _n(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    te(t) && (Be(t, this), _r(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    te(e) && lt(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const r = X(e);
    if (!E.und(r)) {
      const n = oe(this);
      if (!n || !he(r, n.getValue())) {
        const a = Tr(r);
        !n || n.constructor != a ? Br(this, a.create(r)) : n.setValue(r), n && j.batchedUpdates(() => {
          this._onChange(r, t);
        });
      }
    }
    return oe(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, He(
      this,
      "onStart",
      ae(this, Xe(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), _e(this.animation.onChange, e, this)), _e(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    oe(this).reset(X(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), ge(this) || (kn(this, !0), Ze(this) || this._resume());
  }
  _resume() {
    se.skipAnimation ? this.finish() : $t.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (ge(this)) {
      kn(this, !1);
      const r = this.animation;
      C(r.values, (a) => {
        a.done = !0;
      }), r.toValues && (r.onChange = r.onPause = r.onResume = void 0), ct(this, {
        type: "idle",
        parent: this
      });
      const n = t ? $e(this.get()) : ae(this.get(), Xe(this, e ?? r.to));
      Je(this._pendingCalls, n), r.changed && (r.changed = !1, He(this, "onRest", n, this));
    }
  }
};
function Xe(e, t) {
  const r = ht(t), n = ht(e.get());
  return he(n, r);
}
function Va(e, t = e.loop, r = e.to) {
  const n = _e(t);
  if (n) {
    const a = n !== !0 && Ya(n), i = (a || e).reverse, s = !a || a.reset;
    return mt({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !i || Nr(r) ? r : void 0,
      // Ignore the "from" prop except on reset.
      from: s ? e.from : void 0,
      reset: s,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...a
    });
  }
}
function mt(e) {
  const { to: t, from: r } = e = Ya(e), n = /* @__PURE__ */ new Set();
  return E.obj(t) && Yn(t, n), E.obj(r) && Yn(r, n), e.keys = n.size ? Array.from(n) : null, e;
}
function No(e) {
  const t = mt(e);
  return E.und(t.default) && (t.default = Wr(t)), t;
}
function Yn(e, t) {
  ue(e, (r, n) => r != null && t.add(n));
}
var So = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function Fn(e, t, r) {
  e.animation[r] = t[r] !== za(t, r) ? ka(t[r], e.key) : void 0;
}
function He(e, t, ...r) {
  var n, a, i, s;
  (a = (n = e.animation)[t]) == null || a.call(n, ...r), (s = (i = e.defaultProps)[t]) == null || s.call(i, ...r);
}
var _o = ["onStart", "onChange", "onRest"], Do = 1, xo = class {
  constructor(e, t) {
    this.id = Do++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, r) => e[r] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const r = e[t];
      E.und(r) || this.springs[t].set(r);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(mt(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = ee(e).map(mt) : this.queue = [], this._flush ? this._flush(this, t) : (Za(this, t), jr(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const r = this.springs;
      C(ee(t), (n) => r[n].stop(!!e));
    } else
      pt(this._state, this._lastAsyncId), this.each((r) => r.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (E.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      C(ee(e), (r) => t[r].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (E.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      C(ee(e), (r) => t[r].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    ue(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: r } = this._events, n = this._active.size > 0, a = this._changed.size > 0;
    (n && !this._started || a && !this._started) && (this._started = !0, et(e, ([u, l]) => {
      l.value = this.get(), u(l, this, this._item);
    }));
    const i = !n && this._started, s = a || i && r.size ? this.get() : null;
    a && t.size && et(t, ([u, l]) => {
      l.value = s, u(l, this, this._item);
    }), i && (this._started = !1, et(r, ([u, l]) => {
      l.value = s, u(l, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    j.onFrame(this._onFrame);
  }
};
function jr(e, t) {
  return Promise.all(t.map((r) => Ba(e, r))).then(
    (r) => qr(e, r)
  );
}
async function Ba(e, t, r) {
  const { keys: n, to: a, from: i, loop: s, onRest: u, onResolve: l } = t, c = E.obj(t.default) && t.default;
  s && (t.loop = !1), a === !1 && (t.to = null), i === !1 && (t.from = null);
  const d = E.arr(a) || E.fun(a) ? a : void 0;
  d ? (t.to = void 0, t.onRest = void 0, c && (c.onRest = void 0)) : C(_o, (w) => {
    const N = t[w];
    if (E.fun(N)) {
      const I = e._events[w];
      t[w] = ({ finished: m, cancelled: h }) => {
        const S = I.get(N);
        S ? (m || (S.finished = !1), h && (S.cancelled = !0)) : I.set(N, {
          value: null,
          finished: m || !1,
          cancelled: h || !1
        });
      }, c && (c[w] = t[w]);
    }
  });
  const f = e._state;
  t.pause === !f.paused ? (f.paused = t.pause, Je(t.pause ? f.pauseQueue : f.resumeQueue)) : f.paused && (t.pause = !0);
  const v = (n || Object.keys(e.springs)).map(
    (w) => e.springs[w].start(t)
  ), p = t.cancel === !0 || za(t, "cancel") === !0;
  (d || p && f.asyncId) && v.push(
    Fa(++e._lastAsyncId, {
      props: t,
      state: f,
      actions: {
        pause: wr,
        resume: wr,
        start(w, N) {
          p ? (pt(f, e._lastAsyncId), N($e(e))) : (w.onRest = u, N(
            Qa(
              d,
              w,
              f,
              e
            )
          ));
        }
      }
    })
  ), f.paused && await new Promise((w) => {
    f.resumeQueue.add(w);
  });
  const M = qr(e, await Promise.all(v));
  if (s && M.finished && !(r && M.noop)) {
    const w = Va(t, s, a);
    if (w)
      return Za(e, [w]), Ba(e, w, !0);
  }
  return l && j.batchedUpdates(() => l(M, e, e.item)), M;
}
function Un(e, t) {
  const r = { ...e.springs };
  return t && C(ee(t), (n) => {
    E.und(n.keys) && (n = mt(n)), E.obj(n.to) || (n = { ...n, to: void 0 }), Ga(r, n, (a) => qa(a));
  }), Wa(e, r), r;
}
function Wa(e, t) {
  ue(t, (r, n) => {
    e.springs[n] || (e.springs[n] = r, Be(r, e));
  });
}
function qa(e, t) {
  const r = new To();
  return r.key = e, t && Be(r, t), r;
}
function Ga(e, t, r) {
  t.keys && C(t.keys, (n) => {
    (e[n] || (e[n] = r(n)))._prepareNode(t);
  });
}
function Za(e, t) {
  C(t, (r) => {
    Ga(e.springs, r, (n) => qa(n, e));
  });
}
var Zt = ({
  children: e,
  ...t
}) => {
  const r = react.useContext(zt), n = t.pause || !!r.pause, a = t.immediate || !!r.immediate;
  t = ro(() => ({ pause: n, immediate: a }), [n, a]);
  const { Provider: i } = zt;
  return /* @__PURE__ */ react.createElement(i, { value: t }, e);
}, zt = jo(Zt, {});
Zt.Provider = zt.Provider;
Zt.Consumer = zt.Consumer;
function jo(e, t) {
  return Object.assign(e, react.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var Ao = () => {
  const e = [], t = function(n) {
    eo();
    const a = [];
    return C(e, (i, s) => {
      if (E.und(n))
        a.push(i.start());
      else {
        const u = r(n, i, s);
        u && a.push(i.start(u));
      }
    }), a;
  };
  t.current = e, t.add = function(n) {
    e.includes(n) || e.push(n);
  }, t.delete = function(n) {
    const a = e.indexOf(n);
    ~a && e.splice(a, 1);
  }, t.pause = function() {
    return C(e, (n) => n.pause(...arguments)), this;
  }, t.resume = function() {
    return C(e, (n) => n.resume(...arguments)), this;
  }, t.set = function(n) {
    C(e, (a, i) => {
      const s = E.fun(n) ? n(i, a) : n;
      s && a.set(s);
    });
  }, t.start = function(n) {
    const a = [];
    return C(e, (i, s) => {
      if (E.und(n))
        a.push(i.start());
      else {
        const u = this._getProps(n, i, s);
        u && a.push(i.start(u));
      }
    }), a;
  }, t.stop = function() {
    return C(e, (n) => n.stop(...arguments)), this;
  }, t.update = function(n) {
    return C(e, (a, i) => a.update(this._getProps(n, a, i))), this;
  };
  const r = function(n, a, i) {
    return E.fun(n) ? n(i, a) : n;
  };
  return t._getProps = r, t;
};
function Co(e, t, r) {
  const n = E.fun(t) && t;
  n && !r && (r = []);
  const a = react.useMemo(
    () => n || arguments.length == 3 ? Ao() : void 0,
    []
  ), i = react.useRef(0), s = Ra(), u = react.useMemo(
    () => ({
      ctrls: [],
      queue: [],
      flush(I, m) {
        const h = Un(I, m);
        return i.current > 0 && !u.queue.length && !Object.keys(h).some((y) => !I.springs[y]) ? jr(I, m) : new Promise((y) => {
          Wa(I, h), u.queue.push(() => {
            y(jr(I, m));
          }), s();
        });
      }
    }),
    []
  ), l = react.useRef([...u.ctrls]), c = [], d = xn(e) || 0;
  react.useMemo(() => {
    C(l.current.slice(e, d), (I) => {
      yo(I, a), I.stop(!0);
    }), l.current.length = e, f(d, e);
  }, [e]), react.useMemo(() => {
    f(0, Math.min(d, e));
  }, r);
  function f(I, m) {
    for (let h = I; h < m; h++) {
      const S = l.current[h] || (l.current[h] = new xo(null, u.flush)), y = n ? n(h, S) : t[h];
      y && (c[h] = No(y));
    }
  }
  const v = l.current.map((I, m) => Un(I, c[m])), p = react.useContext(Zt), M = xn(p), w = p !== M && go(p);
  Vr(() => {
    i.current++, u.ctrls = l.current;
    const { queue: I } = u;
    I.length && (u.queue = [], C(I, (m) => m())), C(l.current, (m, h) => {
      a == null || a.add(m), w && m.start({ default: p });
      const S = c[h];
      S && (vo(m, S.ref), m.ref ? m.queue.push(S) : m.start(S));
    });
  }), Oa(() => () => {
    C(u.ctrls, (I) => I.stop(!0));
  });
  const N = v.map((I) => ({ ...I }));
  return a ? [N, a] : N;
}
function St(e, t) {
  const r = E.fun(e), [[n], a] = Co(
    1,
    r ? e : [e],
    r ? t || [] : t
  );
  return r || arguments.length == 2 ? [n, a] : n;
}
var Ro = class extends Gr {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = ot(...t);
    const r = this._get(), n = Tr(r);
    Br(this, n.create(r));
  }
  advance(e) {
    const t = this._get(), r = this.get();
    he(t, r) || (oe(this).setValue(t), this._onChange(t, this.idle)), !this.idle && Qn(this._active) && lr(this);
  }
  _get() {
    const e = E.arr(this.source) ? this.source.map(X) : ee(X(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !Qn(this._active) && (this.idle = !1, C(qt(this), (e) => {
      e.done = !1;
    }), se.skipAnimation ? (j.batchedUpdates(() => this.advance()), lr(this)) : $t.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    C(ee(this.source), (t) => {
      te(t) && Be(t, this), _r(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    C(ee(this.source), (e) => {
      te(e) && lt(e, this);
    }), this._active.clear(), lr(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = ee(this.source).reduce(
      (t, r) => Math.max(t, (_r(r) ? r.priority : 0) + 1),
      0
    ));
  }
};
function Oo(e) {
  return e.idle !== !1;
}
function Qn(e) {
  return !e.size || Array.from(e).every(Oo);
}
function lr(e) {
  e.idle || (e.idle = !0, C(qt(e), (t) => {
    t.done = !0;
  }), ct(e, {
    type: "idle",
    parent: e
  }));
}
se.assign({
  createStringInterpolator: Aa,
  to: (e, t) => new Ro(e, t)
});
var Xa = /^--/;
function Po(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !Xa.test(e) && !(nt.hasOwnProperty(e) && nt[e]) ? t + "px" : ("" + t).trim();
}
var $n = {};
function Lo(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const r = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", { style: n, children: a, scrollTop: i, scrollLeft: s, viewBox: u, ...l } = t, c = Object.values(l), d = Object.keys(l).map(
    (f) => r || e.hasAttribute(f) ? f : $n[f] || ($n[f] = f.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (v) => "-" + v.toLowerCase()
    ))
  );
  a !== void 0 && (e.textContent = a);
  for (const f in n)
    if (n.hasOwnProperty(f)) {
      const v = Po(f, n[f]);
      Xa.test(f) ? e.style.setProperty(f, v) : e.style[f] = v;
    }
  d.forEach((f, v) => {
    e.setAttribute(f, c[v]);
  }), i !== void 0 && (e.scrollTop = i), s !== void 0 && (e.scrollLeft = s), u !== void 0 && e.setAttribute("viewBox", u);
}
var nt = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, ko = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), zo = ["Webkit", "Ms", "Moz", "O"];
nt = Object.keys(nt).reduce((e, t) => (zo.forEach((r) => e[ko(r, t)] = e[t]), e), nt);
var Yo = /^(matrix|translate|scale|rotate|skew)/, Fo = /^(translate)/, Uo = /^(rotate|skew)/, fr = (e, t) => E.num(e) && e !== 0 ? e + t : e, jt = (e, t) => E.arr(e) ? e.every((r) => jt(r, t)) : E.num(e) ? e === t : parseFloat(e) === t, Qo = class extends Gt {
  constructor({ x: e, y: t, z: r, ...n }) {
    const a = [], i = [];
    (e || t || r) && (a.push([e || 0, t || 0, r || 0]), i.push((s) => [
      `translate3d(${s.map((u) => fr(u, "px")).join(",")})`,
      // prettier-ignore
      jt(s, 0)
    ])), ue(n, (s, u) => {
      if (u === "transform")
        a.push([s || ""]), i.push((l) => [l, l === ""]);
      else if (Yo.test(u)) {
        if (delete n[u], E.und(s))
          return;
        const l = Fo.test(u) ? "px" : Uo.test(u) ? "deg" : "";
        a.push(ee(s)), i.push(
          u === "rotate3d" ? ([c, d, f, v]) => [
            `rotate3d(${c},${d},${f},${fr(v, l)})`,
            jt(v, 0)
          ] : (c) => [
            `${u}(${c.map((d) => fr(d, l)).join(",")})`,
            jt(c, u.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), a.length && (n.transform = new $o(a, i)), super(n);
  }
}, $o = class extends Da {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return C(this.inputs, (r, n) => {
      const a = X(r[0]), [i, s] = this.transforms[n](
        E.arr(a) ? a : r.map(X)
      );
      e += " " + i, t = t && s;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && C(
      this.inputs,
      (t) => C(
        t,
        (r) => te(r) && Be(r, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && C(
      this.inputs,
      (t) => C(
        t,
        (r) => te(r) && lt(r, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), ct(this, e);
  }
}, Vo = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
se.assign({
  batchedUpdates: reactDom.unstable_batchedUpdates,
  createStringInterpolator: Aa,
  colors: As
});
var Bo = lo(Vo, {
  applyAnimatedValues: Lo,
  createAnimatedStyle: (e) => new Qo(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...r }) => r
}), _t = Bo.animated;
function Wo({ size: e = 40, color: t = "#fff" }) {
  return /* @__PURE__ */ V.jsxs("div", { "data-ticketbutler-spinner": "", style: { width: e, height: e }, children: [
    /* @__PURE__ */ V.jsx(
      "div",
      {
        style: {
          border: "4px solid",
          borderColor: t + " transparent transparent transparent",
          animationDelay: "-0.45s"
        }
      }
    ),
    /* @__PURE__ */ V.jsx(
      "div",
      {
        style: {
          border: "4px solid",
          borderColor: t + " transparent transparent transparent",
          animationDelay: "-0.3s"
        }
      }
    ),
    /* @__PURE__ */ V.jsx(
      "div",
      {
        style: {
          border: "4px solid",
          borderColor: t + " transparent transparent transparent",
          animationDelay: "-0.15s"
        }
      }
    ),
    /* @__PURE__ */ V.jsx("div", {})
  ] });
}
function Jo({
  children: e,
  loading: t,
  loadingMessage: r,
  success: n,
  successMessage: a
}) {
  const i = St({ opacity: !t && !n ? 1 : 0 }), s = St({ opacity: t ? 1 : 0 }), u = St({ opacity: n ? 1 : 0 }), l = St({
    opacity: t ? 1 : 0,
    top: t ? "115%" : "50%"
  });
  return react.cloneElement(e, {
    disabled: e.props.disabled || t || n,
    style: { ...e.props.style, position: "relative" },
    children: !t && !n ? /* @__PURE__ */ V.jsx(_t.div, { style: i, children: e.props.children }) : t ? /* @__PURE__ */ V.jsxs(react.Fragment, { children: [
      /* @__PURE__ */ V.jsx(
        _t.div,
        {
          style: {
            ...s,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          },
          children: /* @__PURE__ */ V.jsx(Wo, {})
        }
      ),
      t && /* @__PURE__ */ V.jsx(
        _t.div,
        {
          style: {
            ...l,
            position: "absolute",
            textAlign: "center",
            // Appear from underneath the button
            zIndex: -1
          },
          children: r
        }
      )
    ] }) : /* @__PURE__ */ V.jsx(_t.div, { style: u, children: a })
  });
}

export { Ko as LanguageSelector, Jo as LoadingButton, Wo as Spinner, Xo as formatDate, Ho as formatDateTimeRange, Zo as makeDate };
